import { Link } from "@tanstack/react-router";
import { Sparkles } from "lucide-react";
import { toast, Button } from "@dishfolio/ui";
import { ApiError, errorMessage } from "../lib/api.ts";

/** Show API errors; plan-limit errors get an upgrade call to action. */
export function notifyError(err: unknown) {
  const planLimit = err instanceof ApiError ? err.isPlanLimit : Boolean((err as { isPlanLimit?: boolean })?.isPlanLimit);
  const message = err instanceof ApiError || err instanceof Error ? errorMessage(err) : ((err as { message?: string })?.message ?? errorMessage(err));
  if (planLimit) {
    toast.error(message, { action: { label: "See plans", onClick: () => (window.location.href = "/billing") } });
    return;
  }
  toast.error(message);
}

export function UpgradeCard({ title, description, plan = "Pro" }: { title: string; description: string; plan?: "Pro" | "Business" }) {
  return (
    <div className="flex flex-col items-start gap-3 rounded-xl border border-primary/20 bg-gradient-to-br from-primary/5 to-transparent p-5">
      <div className="flex items-center gap-2 font-medium">
        <Sparkles className="size-4 text-primary" /> {title}
      </div>
      <p className="text-sm text-muted-foreground">{description}</p>
      <Button asChild size="sm">
        <Link to="/billing">Upgrade to {plan}</Link>
      </Button>
    </div>
  );
}

/** Shown when a page is opened directly while its feature flag is off. */
export function FeatureUnavailable({ title }: { title: string }) {
  return (
    <div className="mx-auto grid max-w-xl gap-3 p-8 text-center">
      <h1 className="font-display text-2xl font-semibold">{title} isn’t available yet</h1>
      <p className="text-sm text-muted-foreground">We’re still putting the finishing touches on it. It will show up in your menu as soon as it’s ready.</p>
    </div>
  );
}
